import { isBindingContextLoaded } from "../../../common/module-guard";

import { DefaultCanvasRichTextRender } from "./richtext-render";

import { GraphicRender, RichTextRender } from "./symbol";

const loadedRichtextModuleContexts = new WeakSet;

export function bindRichtextRenderModule({bind: bind}) {
    isBindingContextLoaded(loadedRichtextModuleContexts, bind) || (bind(DefaultCanvasRichTextRender).toDynamicValue((() => new DefaultCanvasRichTextRender)).inSingletonScope(), 
    bind(RichTextRender).toService(DefaultCanvasRichTextRender), bind(GraphicRender).toService(RichTextRender));
}

export const richtextModule = bindRichtextRenderModule;
//# sourceMappingURL=richtext-module.js.map
